'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { Sustainability } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/Sustainability/Sustainability'
import { cx } from 'utils/cx'

import styles from './AccordionTitle.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface AccordionTitleProps {
	readonly 'data-testid'?: string
	readonly cost?: string | null
	readonly title: string
	readonly subtitle?: string | null
	readonly isFree?: boolean
	readonly hasEcoContent?: boolean
}
export function AccordionTitle({
	'data-testid': dataTestId,
	cost,
	title,
	subtitle = null,
	isFree = false,
	hasEcoContent = false,
}: AccordionTitleProps) {
	const { t } = useLabels()

	const costValue = isFree
		? t('myPurchases.online.details.returns.isFree.text')
		: cost
	return (
		<>
			<span
				data-testid={`${dataTestId}.title`}
				className={`${text.titleM} ${styles.storeTitle}`}
			>
				{title}
				{costValue && hasEcoContent && (
					<Sustainability hideLabel className={styles.eco} />
				)}
			</span>
			{!costValue && hasEcoContent && <Sustainability />}
			{costValue && !subtitle && (
				<span
					data-testid={`${dataTestId}.cost`}
					className={cx(text.bodyS, styles.cost)}
				>
					{costValue}
				</span>
			)}
			{subtitle && (
				<span
					data-testid={`${dataTestId}.subtitle`}
					className={cx(text.bodyS, styles.cost)}
				>
					{subtitle}
				</span>
			)}
		</>
	)
}
